import { types } from '../actions/types';

export const BlogReducer = (
  state = {
    get: null,
    create: null,
    update: null,
    deleteById: null,
  },
  action,
) => {
  switch (action.type) {
    case types.blgGetBlogs:
      return { ...state, get: action.payload };
    case types.blgCreateBlog:
      return { ...state, create: action.payload };
    case types.blgUpdateBlog:
      return { ...state, update: action.payload };
    case types.blgDeleteBlogById:
      return { ...state, deleteById: action.payload };
    default:
      return state;
  }
};
